import { createApp } from 'vue';
import cmpContact from '../vue/Contact.vue';

window.Contact = (function(){
	const component = createApp(cmpContact, {});
	return component.mount('#component-contact');
})();